export const modalStyles = { content: { padding: "0", border: "unset", width: "600px" } };
